import React, { Component } from 'react'
import { Form, Input, Button } from 'antd'

const layout = {
  labelCol: {
    md: {
      span: 4
    }
  },
  wrapperCol: {
    md: {
      span: 6
    }
  }
}

class SettingsPasswordForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.updateUserPassword(values.oldPassword, values.newPassword)
        this.handleReset()
      }
    })
  }

  handleReset = () => {
    this.props.form.resetFields()
  }

  render () {
    const { user } = this.props
    const { getFieldDecorator } = this.props.form

    return (
      <div className='page-settings__form'>
        <Form onSubmit={this.handleSubmit} className='form'>
          <fieldset className='fieldset form__fieldset'>
            <legend className='legend fieldset__legend'>My Password</legend>
            <Form.Item {...layout} label='Old Password'>
              {getFieldDecorator('oldPassword', {
                rules: [{ required: true,
                  message: 'Please input your old password',
                  max: 320
                }]
              })(
                <Input type='password' name='oldPassword' />
              )}
            </Form.Item>
            <Form.Item {...layout} label='New Password'>
              {getFieldDecorator('newPassword', {
                rules: [{ required: true,
                  message: 'Please input your new password',
                  max: 320
                }]
              })(
                <Input type='password' name='newPassword' />
              )}
            </Form.Item>
          </fieldset>
          <Form.Item>
            <Button type='indigo' htmlType='submit' loading={user.isPasswordUpdating}>Update Password</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

export default Form.create()(SettingsPasswordForm)



// WEBPACK FOOTER //
// ./src/views/Settings/components/PasswordForm/PasswordForm.jsx